import { InjectionToken } from "@angular/core";
import { ISplashLoaderService } from "./i-splash-loader.service";

export const splashLoaderServiceInjectionToken: InjectionToken<ISplashLoaderService> = new InjectionToken<ISplashLoaderService>("digital-signage.user-dashboard.dashboard-web.SplashLoaderService");
